//same as the one defined in variables.scss
const mq = {
  xs: 0,
  sm: window.matchMedia('(min-width: 375px)'), 
  md: window.matchMedia('(min-width: 768px)'),
  mobile: window.matchMedia('(max-width: 767px)'),
  tablet: window.matchMedia('(min-width : 768px) and (max-width : 1139px)'),
  md2: window.matchMedia('(min-width: 1024px)'),
  lg: window.matchMedia('(min-width: 1140px)'),
  xl: window.matchMedia('(min-width: 1600px)')
};

export { mq };
